import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = { "clip-path": "url(#clip0_11969_54503)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = { "clip-path": "url(#clip1_11969_54503)" }
const _hoisted_7 = ["fill"]
const _hoisted_8 = ["fill"]
const _hoisted_9 = ["fill"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_11969_54503" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "4",
      height: "12",
      fill: "white"
    })
  ]),
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip1_11969_54503" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "4",
      height: "12",
      fill: "white",
      transform: "translate(4)"
    })
  ])
], -1)

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'draggableIcon',
  props: {
  width: {
    type: Number as PropType<number>,
    default: 8,
  },
  height: {
    type: Number as PropType<number>,
    default: 12,
  },
  color: {
    type: String as PropType<string>,
    default: "#B7B7B7",
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.width,
    height: __props.height,
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M0.763672 10.043C0.763672 10.3693 0.893311 10.6823 1.12407 10.913C1.35483 11.1438 1.6678 11.2734 1.99414 11.2734C2.32048 11.2734 2.63346 11.1438 2.86421 10.913C3.09497 10.6823 3.22461 10.3693 3.22461 10.043C3.22461 9.71663 3.09497 9.40365 2.86421 9.1729C2.63346 8.94214 2.32048 8.8125 1.99414 8.8125C1.6678 8.8125 1.35483 8.94214 1.12407 9.1729C0.893311 9.40365 0.763672 9.71663 0.763672 10.043Z",
        fill: __props.color
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M0.763672 1.95703C0.763672 2.28337 0.893311 2.59635 1.12407 2.8271C1.35483 3.05786 1.6678 3.1875 1.99414 3.1875C2.32048 3.1875 2.63346 3.05786 2.86421 2.8271C3.09497 2.59635 3.22461 2.28337 3.22461 1.95703C3.22461 1.63069 3.09497 1.31772 2.86421 1.08696C2.63346 0.856201 2.32048 0.726563 1.99414 0.726562C1.6678 0.726563 1.35483 0.856201 1.12407 1.08696C0.893311 1.31772 0.763672 1.63069 0.763672 1.95703Z",
        fill: __props.color
      }, null, 8, _hoisted_4),
      _createElementVNode("path", {
        d: "M0.763672 6C0.763672 6.32634 0.893311 6.63932 1.12407 6.87007C1.35483 7.10083 1.6678 7.23047 1.99414 7.23047C2.32048 7.23047 2.63346 7.10083 2.86421 6.87007C3.09497 6.63932 3.22461 6.32634 3.22461 6C3.22461 5.67366 3.09497 5.36068 2.86421 5.12993C2.63346 4.89917 2.32048 4.76953 1.99414 4.76953C1.6678 4.76953 1.35483 4.89917 1.12407 5.12993C0.893311 5.36068 0.763672 5.67366 0.763672 6Z",
        fill: __props.color
      }, null, 8, _hoisted_5)
    ]),
    _createElementVNode("g", _hoisted_6, [
      _createElementVNode("path", {
        d: "M4.76367 10.043C4.76367 10.3693 4.89331 10.6823 5.12407 10.913C5.35483 11.1438 5.6678 11.2734 5.99414 11.2734C6.32048 11.2734 6.63346 11.1438 6.86421 10.913C7.09497 10.6823 7.22461 10.3693 7.22461 10.043C7.22461 9.71663 7.09497 9.40365 6.86421 9.1729C6.63346 8.94214 6.32048 8.8125 5.99414 8.8125C5.6678 8.8125 5.35483 8.94214 5.12407 9.1729C4.89331 9.40365 4.76367 9.71663 4.76367 10.043Z",
        fill: __props.color
      }, null, 8, _hoisted_7),
      _createElementVNode("path", {
        d: "M4.76367 1.95703C4.76367 2.28337 4.89331 2.59635 5.12407 2.8271C5.35483 3.05786 5.6678 3.1875 5.99414 3.1875C6.32048 3.1875 6.63346 3.05786 6.86421 2.8271C7.09497 2.59635 7.22461 2.28337 7.22461 1.95703C7.22461 1.63069 7.09497 1.31772 6.86421 1.08696C6.63346 0.856201 6.32048 0.726563 5.99414 0.726562C5.6678 0.726563 5.35483 0.856201 5.12407 1.08696C4.89331 1.31772 4.76367 1.63069 4.76367 1.95703Z",
        fill: __props.color
      }, null, 8, _hoisted_8),
      _createElementVNode("path", {
        d: "M4.76367 6C4.76367 6.32634 4.89331 6.63932 5.12407 6.87007C5.35483 7.10083 5.6678 7.23047 5.99414 7.23047C6.32048 7.23047 6.63346 7.10083 6.86421 6.87007C7.09497 6.63932 7.22461 6.32634 7.22461 6C7.22461 5.67366 7.09497 5.36068 6.86421 5.12993C6.63346 4.89917 6.32048 4.76953 5.99414 4.76953C5.6678 4.76953 5.35483 4.89917 5.12407 5.12993C4.89331 5.36068 4.76367 5.67366 4.76367 6Z",
        fill: __props.color
      }, null, 8, _hoisted_9)
    ]),
    _hoisted_10
  ], 8, _hoisted_1))
}
}

})